// frontend/src/components/cash-close/DriveSyncBadge.js
import React, { useState } from 'react';
import { useTheme, sans, green, amber, red } from '../../tokens';
import SyncHistoryModal from './SyncHistoryModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

function dotColor(meta) {
  if (!meta?.synced_at) return red;
  const ageHrs = (Date.now() - new Date(meta.synced_at).getTime()) / 3600000;
  if (ageHrs < 2)  return green;
  if (ageHrs < 24) return amber;
  return red;
}

function timeAgo(iso) {
  if (!iso) return 'never';
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1)   return 'just now';
  if (mins < 60)  return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24)   return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export default function DriveSyncBadge({ companyId, meta, onSyncDone }) {
  const t = useTheme();
  const [syncing, setSyncing] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  const runSync = async () => {
    setSyncing(true);
    try {
      await fetch(`${BACKEND_URL}/api/forecast/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          company_id: companyId,
          sheet_id: process.env.REACT_APP_FORECAST_SHEET_ID || '1_j1sJ_DW_SXI7RjwQPeJ09hIs2jWf-ErGarMzmkFa8Y',
          sheet_tab: 'MPD CAD',
          trigger: 'manual',
        }),
      });
      if (onSyncDone) onSyncDone();
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      padding: '4px 10px',
      border: `1px solid ${t.border}`, borderRadius: 14,
      background: t.bgCard, fontFamily: sans, fontSize: 11, color: t.textSecondary,
    }}>
      <span style={{
        width: 8, height: 8, borderRadius: 4, background: dotColor(meta),
      }} />
      <span
        onClick={() => setHistoryOpen(true)}
        style={{ cursor: 'pointer' }}
        title="Click to view sync history"
      >
        {meta
          ? `Forecast synced ${timeAgo(meta.synced_at)} from Drive · ${meta.sheet_tab || 'MPD CAD'}`
          : 'Forecast: legacy fallback (Drive not connected)'}
      </span>
      <button
        onClick={runSync}
        disabled={syncing}
        style={{
          marginLeft: 4, fontSize: 10, padding: '2px 8px',
          border: 'none', borderRadius: 10,
          background: green, color: '#fff', cursor: syncing ? 'wait' : 'pointer',
          opacity: syncing ? 0.6 : 1, fontFamily: sans, fontWeight: 600,
        }}
      >
        {syncing ? 'Syncing…' : 'Sync now'}
      </button>
      <SyncHistoryModal
        companyId={companyId}
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        onRevertDone={onSyncDone}
      />
    </div>
  );
}
